/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {formatDate} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {FabMessageService} from '@fabric/components/message';
import {BUSINESS_PLAN, DISMISS_MSG, FCORG_BLACKLIST, GMTVP, TVP} from '../../../../common/constants';
import {StateService} from '../../../../core/state/state.service';
import {SelectableOptions} from '../../../../models/selectable-options';
import {ExcelExportService} from '../../../../services/excel-export.service';
import {FcorgService} from '../../../../services/fcorg.service';
import {ReportService} from '../../../../services/report.service';

@Component({
    selector: 'app-vehicle-portfolio-report',
    templateUrl: './vehicle-portfolio-report.component.html',
    styleUrl: './vehicle-portfolio-report.component.scss',
    standalone: false
})
export class VehiclePortfolioReportComponent implements OnInit {
  showSpinner: boolean;
  fcorgs = new SelectableOptions();
  portTypes = [
    {
      id: 0,
      label: BUSINESS_PLAN
    },
    {
      id: 1,
      label: TVP
    }
  ];
  selectedPortType: { id: number, label: string };
  multipleSheets: boolean;

  constructor(readonly reportService: ReportService,
              readonly stateService: StateService,
              readonly fcorgService: FcorgService,
              readonly excelService: ExcelExportService,
              public dialog: MatDialog,
              public snackBar: FabMessageService) {
  }

  ngOnInit() {
    this.showSpinner = false;
    this.selectedPortType = this.portTypes[0];
    this.multipleSheets = false;
    this.getFcorgs();
  }


  /**
   * Gets the fcorgs the user has access to
   */
  getFcorgs() {
    this.showSpinner = true;
    this.fcorgService.getFcorgsById(this.stateService.getUserGmid()).subscribe({
        next: (data) => {
          const customFcorgBlacklist = FCORG_BLACKLIST.concat(["GME", GMTVP])
          this.fcorgs.options = data.filter((element: string) => !customFcorgBlacklist.includes(element));
        },
        error: (error) => {
          this.snackBar.displayError(error, DISMISS_MSG);
          this.showSpinner = false;
        },
        complete: () => {
          this.showSpinner = false;
        }
      }
    );
  }


  /**
   * Event handler for change in portfolio type
   */
  onPortTypeChange() {
    this.fcorgs.selectedOptions = [];
    if (this.selectedPortType.id === 1) {
      this.fcorgs.options = [GMTVP];
    } else {
      this.getFcorgs();
    }
    // Reset the multiple tabs checkbox
    this.multipleSheets = false;
  }

  /**
   * gets the portfolio report
   */
  getPortfolioReport() {
    const currDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    const fileName = 'VehPort_' + currDate;

    this.showSpinner = true;
    this.reportService.getVehPortfolioReport(this.fcorgs.selectedOptions, this.multipleSheets, this.selectedPortType.label).subscribe(
      {
        next: (data) => {
          this.excelService.exportToExcelFromServer(data, fileName);
        },
        error: (error) => {
          this.showSpinner = false;
          this.snackBar.displayError(error, DISMISS_MSG);
        },
        complete: () => {
          this.showSpinner = false;
          this.snackBar.displaySuccess('Successfully retrieved data. Exporting...', DISMISS_MSG);

        }
      }
    );
  }
}
